module.exports = __webpack_public_path__ + "static/media/3.43bc5064.jpg";